import React, { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useResumeStore } from "../../store/resumeStore";
import { SAMPLE_RESUME_DATA } from "./sampleResumeData";
import { getTemplateOptionById } from "./templateCatalog";
import TemplateRenderer from "./templateRenderer";

const AUDIT_RESUME = {
  ...SAMPLE_RESUME_DATA,
  photo:
    "data:image/svg+xml;charset=utf-8," +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160"><rect width="160" height="160" fill="#dbeafe"/><circle cx="80" cy="60" r="30" fill="#2563eb"/><path d="M25 150c8-38 31-57 55-57s47 19 55 57" fill="#2563eb"/></svg>',
    ),
  projects: [
    {
      name: "Resume Analytics Platform",
      role: "Lead Product Designer",
      years: "2024",
      technologies: ["React", "Node.js", "PostgreSQL"],
      description:
        "<ul><li>Designed a resume quality dashboard with section-level scoring.</li><li>Validated workflows with recruiters and job seekers.</li></ul>",
    },
  ],
  certifications: ["Google UX Design Professional Certificate"],
  awards: ["Product Design Excellence Award, 2025"],
  publications: ["Designing Trustworthy Career Tools, UX Review, 2025"],
  customSections: [
    {
      title: "Open Source",
      items: ["Maintainer of an accessible React component toolkit."],
    },
  ],
  socialLinks: [
    { label: "LinkedIn", url: "https://linkedin.com/in/aaravmehta" },
    { label: "GitHub", url: "https://github.com/aaravmehta" },
  ],
};

export default function TemplateAuditPage() {
  const [searchParams] = useSearchParams();
  const requestedTemplateId = searchParams.get("template") || "template12";
  const templateId = getTemplateOptionById(requestedTemplateId).id;
  const setResume = useResumeStore((state) => state.setResume);
  const setSelectedTemplateId = useResumeStore(
    (state) => state.setSelectedTemplateId,
  );

  useEffect(() => {
    setResume(AUDIT_RESUME);
    setSelectedTemplateId(templateId, "template-audit");
  }, [setResume, setSelectedTemplateId, templateId]);

  const pageStyle = useMemo(
    () => ({
      width: "210mm",
      minHeight: "297mm",
      margin: 0,
      background: "#ffffff",
      overflow: "visible",
    }),
    [],
  );

  useEffect(() => {
    const markReady = async () => {
      await document.fonts?.ready;
      await Promise.all(
        [...document.images].map((image) =>
          image.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                image.addEventListener("load", resolve, { once: true });
                image.addEventListener("error", resolve, { once: true });
              }),
        ),
      );
      window.__RESUMEIQ_TEMPLATE_AUDIT_READY__ = true;
    };
    markReady();
  }, [templateId]);

  return (
    <div
      id="resumeiq-template-audit-root"
      data-template-id={templateId}
      style={pageStyle}
    >
      <TemplateRenderer templateId={templateId} />
    </div>
  );
}

